module.exports = __webpack_public_path__ + "static/media/isdoctorplan-gastro2@2x.0513316d.png";